
import { EavesBoard } from "@/commons/interface/building/eaves-board";
import qs from "qs";
import { StdResponse, bimAxios } from "@/config/axios"

export function addEavesBoard(projectUuid: string, data: EavesBoard, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/eaves-boards`, data, {
        params: {
            ...params,
        }
    })
}

export function findEavesBoardsByprojectUuid(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/projects/${projectUuid}/eaves-boards`, {
        params: {
            ...params,
        }
    })
}

export function updateEavesById(id: number, data: EavesBoard, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/eaves-boards/${id}`, data, {
        params: {
            ...params,
        },

    })
}

export function deleteEavesBoardByIdList(ids: number[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/eaves-boards`, {
        params: {
            ids: ids,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}